import React, { useCallback, useState } from "react";

import { useDropzone } from "react-dropzone";
import axios from "axios";
import { homepage } from "../../constants/common";
import "./Dropzone.css";

const Dropzone = () => {
  const [image, setImage] = useState([]);
  const [name, setIGN] = useState("");

  const handleIgnChange = (event) => {
    setIGN(event.target.value);
  };

  const onDrop = useCallback((acceptedFiles, name) => {
    var dither =
      document.querySelector(".ditheringBox:checked") === null ? false : true;
    var formData = new FormData();
    formData.append("newImage", acceptedFiles[0]);
    formData.append("imagedrop", "imagedrop");
    formData.append("dither", dither);

    if (name !== undefined) {
      if (name.length > 0) formData.append("name", name);
    }

    axios
      .post(homepage + "/mabivcc.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res.data);
        setImage(res.data);
      });
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, name),
  });

  return (
    <div>
      <div {...getRootProps({ className: "dropzone" })}>
        <input className="input-zone" {...getInputProps()} />
        <span className="dropzone-content">
          {isDragActive ? (
            <p>
              Ready to convert<br></br>
              <br></br>Drop an image here, or click to select one
            </p>
          ) : (
            <p>
              Choose options then<br></br>
              <br></br>Drop an image here, or click to select one
            </p>
          )}
        </span>
      </div>
      <div className="image-options">
        <div className="ign">
          <label>IGN: </label>
          <input
            className="ignInput"
            type="text"
            placeholder="(Optional)"
            maxLength="16"
            id="name"
            name="name"
            value={name}
            onChange={handleIgnChange}
          ></input>
        </div>
        <div className="column">
          <div className="dithering">
            <p>Enable Dithering</p>
            <label className="switch">
              <input className="ditheringBox" type="checkbox"></input>
              <span className="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div className="converted">
        <span>
          {image.indexOf("convert") === -1 ? (
            <br></br>
          ) : (
            <a download href={homepage + "/" + image} title={image.substr(15)}>
              <img
                className="image-converted"
                src={homepage + "/" + image}
                width={512}
                height={192}
              />
            </a>
          )}
        </span>
      </div>
    </div>
  );
};

const ConvertedImage = ({ image }) => <img src={homepage + "/" + image} />;

export default Dropzone;
